import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Set from "@babel/runtime-corejs3/core-js-stable/set";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof _Object$getOwnPropertySymbols === "function") for (var i = 0, p = _Object$getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React, { useContext, useEffect, useState } from 'react';
import { toArray } from '../_utils/react-children';
import { ConfigContext } from '../config-provider';
import { getCompProps } from '../_utils';
import classNames from 'classnames';
import devWarning from '../_utils/devwarning';
import MenuItem from './menuItem';
import SubMenu from './subMenu';
var isFunction = function isFunction(fn) {
  return fn && typeof fn === 'function';
};
var openSubMenuSet = new _Set();
var Menu = function Menu(props) {
  var _context2, _classNames;
  var _a;
  var _useContext = useContext(ConfigContext),
    getPrefixCls = _useContext.getPrefixCls,
    pkgPrefixCls = _useContext.prefixCls,
    userDefaultProps = _useContext.compDefaultProps;
  var userSelectedKey = props.selectedKey,
    userOpenKeys = props.openKeys;
  var _b = getCompProps('Menu', userDefaultProps, props),
    customPrefixcls = _b.prefixCls,
    mode = _b.mode,
    inlineIndent = _b.inlineIndent,
    forceSubMenuRender = _b.forceSubMenuRender,
    additionalTools = _b.additionalTools,
    onClick = _b.onClick,
    onOpenChange = _b.onOpenChange,
    children = _b.children,
    className = _b.className,
    theme = _b.theme,
    collapsed = _b.collapsed,
    accordion = _b.accordion,
    defaultOpenKeys = _b.defaultOpenKeys,
    restProps = __rest(_b, ["prefixCls", "mode", "inlineIndent", "forceSubMenuRender", "additionalTools", "onClick", "onOpenChange", "children", "className", "theme", "collapsed", "accordion", "defaultOpenKeys"]);
  var prefixCls = getPrefixCls(pkgPrefixCls, 'menu', customPrefixcls);
  devWarning(['inline', 'vertical', undefined].indexOf(mode) === -1, 'menu', "cannot found menu mode '".concat(mode, "'"));
  devWarning(mode !== 'inline' && accordion !== undefined, 'menu', "'accordion' is valid only in mode='inline'");
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    selectedKey = _useState2[0],
    setSelectedKey = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedKeyPath = _useState4[0],
    setSelectedKeyPath = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    openKeys = _useState6[0],
    setOpenKeys = _useState6[1];
  if (mode === 'inline') {
    restProps.triggerSubMenuAction = 'click';
  }
  useEffect(function () {
    setOpenKeys([]);
    setSelectedKey('');
    setSelectedKeyPath([]);
    openSubMenuSet.clear();
  }, [mode]);
  useEffect(function () {
    if (userSelectedKey !== undefined) {
      setSelectedKey(userSelectedKey);
    }
  }, [userSelectedKey]);
  useEffect(function () {
    if (Array.isArray(defaultOpenKeys)) {
      setOpenKeys(defaultOpenKeys);
      defaultOpenKeys.forEach(function (d) {
        openSubMenuSet.add(d);
      });
    }
  }, []);
  useEffect(function () {
    if (userOpenKeys !== undefined && Array.isArray(userOpenKeys)) {
      setOpenKeys(userOpenKeys);
      openSubMenuSet.clear();
      userOpenKeys.forEach(function (d) {
        openSubMenuSet.add(d);
      });
    }
  }, [userOpenKeys]);
  var handleOnClick = function handleOnClick(info) {
    if (userSelectedKey === undefined) {
      setSelectedKey(info.key);
    }
    if (mode !== 'inline' && openKeys.length > 0) {
      setOpenKeys([]);
      openSubMenuSet.clear();
    }
    onClick && onClick(info);
  };
  var handleMouseEnterMenu = function handleMouseEnterMenu() {
    if (isFunction(restProps.onMouseEnter)) {
      restProps.onMouseEnter();
    }
  };
  var handleMouseLeaveMenu = function handleMouseLeaveMenu() {
    if (isFunction(restProps.onMouseLeave)) {
      restProps.onMouseLeave();
    }
  };
  // 子菜单展开关闭的回调
  var handleOnOpenChange = function handleOnOpenChange(openKey, isAdd) {
    var clean = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    if (clean) {
      openSubMenuSet.clear();
    } else {
      if (mode === 'inline' && accordion) {
        openSubMenuSet.clear();
      }
      if (isAdd) {
        openSubMenuSet.add(openKey);
      } else {
        openSubMenuSet.delete(openKey);
      }
    }
    if (userOpenKeys === undefined) {
      setOpenKeys(_toConsumableArray(openSubMenuSet));
    }
    onOpenChange && onOpenChange(_toConsumableArray(openSubMenuSet));
  };
  var renderMenu = function renderMenu() {
    var _context;
    return /*#__PURE__*/React.createElement("ul", null, _mapInstanceProperty(_context = toArray(children)).call(_context, function (item, i) {
      if (!item) return;
      var key = (item === null || item === void 0 ? void 0 : item.key) || i;
      return /*#__PURE__*/React.cloneElement(item, {
        key: key,
        keyValue: key,
        collapsed: collapsed,
        mode: mode,
        openKeys: openKeys,
        selectedKey: selectedKey,
        selectedKeyPath: selectedKeyPath,
        setSelectedKeyPath: setSelectedKeyPath,
        theme: theme,
        triggerSubMenuAction: restProps.triggerSubMenuAction,
        forceSubMenuRender: forceSubMenuRender,
        handleOnOpenChange: handleOnOpenChange,
        handleOnClick: handleOnClick,
        inlineIndent: inlineIndent,
        userOpenKeys: userOpenKeys,
        userSelectedKey: userSelectedKey
      });
    }));
  };
  var style = _extends(_extends({}, restProps.style), {
    width: !collapsed && ((_a = restProps.style) === null || _a === void 0 ? void 0 : _a.width),
    transition: 'width 0.2s cubic-bezier(0,.4,.4,1)'
  });
  var mouseEvent = {
    onMouseLeave: handleMouseLeaveMenu,
    onMouseEnter: handleMouseEnterMenu
  };
  return /*#__PURE__*/React.createElement("div", _extends({
    className: classNames(prefixCls, className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-inline"), mode === 'inline'), _defineProperty(_classNames, "".concat(prefixCls, "-vertical"), mode !== 'inline'), _defineProperty(_classNames, "".concat(prefixCls, "-collapsed"), collapsed), _defineProperty(_classNames, _concatInstanceProperty(_context2 = "".concat(prefixCls, "-")).call(_context2, theme === 'light' ? 'light' : 'dark'), true), _classNames)),
    role: "menu",
    style: style
  }, mouseEvent), children && renderMenu(), additionalTools);
};
Menu.displayName = 'Menu';
Menu.Item = MenuItem;
Menu.SubMenu = SubMenu;
export default Menu;